import axios from 'axios'
import jwtDecode from 'jwt-decode'
import Cookies from 'js-cookie'

let savedToken = window.localStorage.getItem('token')
let tokenData = savedToken ? JSON.parse(savedToken) : {}
let cookieToken = Cookies.get('siteToken')

if (tokenData && tokenData.expiration) {
  tokenData.expiration = new Date(tokenData.expiration)
}

if(!cookieToken && savedToken && JSON.parse(savedToken).authorizationToken) {
  let storedTokenExpiry = decodeToken(JSON.parse(savedToken).authorizationToken)
  Cookies.set('siteToken', JSON.parse(savedToken).authorizationToken, { expires: storedTokenExpiry, path: '/' })
}


function decodeToken(token) {
  var authToken = jwtDecode(token);
  var tokenExp = authToken.exp
  var date = new Date(tokenExp * 1000);
  return date
}

export function setToken(t) {
  if (!t || !t.authorizationToken){
    throw(new Error('Invalid request to update token'))
  }
  var tokenExpiryTime = decodeToken(t.authorizationToken)
  tokenData = {
    expiration: tokenExpiryTime.getTime(),
    authorizationToken: t.authorizationToken,
    refreshToken: t.refreshToken,
    duration: tokenExpiryTime.getTime() - new Date().getTime()
  }
  window.localStorage.setItem('token', JSON.stringify(tokenData))
  Cookies.set('siteToken', t.authorizationToken, { expires: tokenExpiryTime, path: '/' })
}

export function clearToken() {
  console.log('Clearing token.')
  window.localStorage.removeItem('token')
  Cookies.set('siteToken', "")
  tokenData = {}
}

export function getToken(cb) {
  let user = window.localStorage.getItem("user") 
  let userData = user ? JSON.parse(user) : {}

  return new Promise((resolve, reject) => {
    if (tokenData.authorizationToken) {
      var now = new Date().getTime();
      if (now < tokenData.expiration) {
        if (cb) cb(tokenData.authorizationToken, tokenData.refreshToken)
        resolve(tokenData.authorizationToken, tokenData.refreshToken)
        return
      }
    }

    if (tokenData.refreshToken || (userData && userData.user && Object.keys(userData).length > 0)) {
      // console.log('refreshing token')
      axios({
        method: 'GET',
        url: `${ window.settings.apiBaseUrl }/identity/refresh/${ tokenData.refreshToken || userData.user.refreshToken }`,
      }).then( res => {
        var d = res.data && {
          authorizationToken: res.data.authorization_token,
          refreshToken: res.data.refresh_token
        }
        setToken(d)
        if (cb) cb(d.authorizationToken, d.refreshToken)
        resolve(d.authorizationToken, tokenData.refreshToken)
      }).catch(err => {
        console.error('Error refreshing token', err)
        clearToken()
        reject(err)
      })
      return
    }

    // If user, remove user
    var url = 
      window.SERVER_SIDE_RENDERING ? 
        `${ window.settings.apiBaseUrl }/identity/server-token` :
        `${ window.settings.apiBaseUrl }/identity/anonymous-token`

    // Fetch token
    axios({
      method: "GET",
      url: url,
      params: { site: window.settings.internalName },
      headers: {
        "x-api-key": window.settings.baseAPIKey
      }
    })
    .then(res => {
      var d = res.data && { authorizationToken: res.data.authorizationToken };
      setToken(d);
      if (cb) cb(d.authorizationToken, d.refreshToken);
      resolve(d.authorizationToken, d.refreshToken);
    })
    .catch(err => {
      console.error("Error fetching anonymous token", err);
      reject(err);
    });
  })
}